module.exports = __webpack_public_path__ + "static/media/2 kids.34ba86c8.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/img/2 kids.jpg
 ** module id = 380
 ** module chunks = 0
 **/